export const TOKENS_STORAGE_KEY = 'featureFlagRollout.tokens';

/** Tonkean tokens by environment, as loaded on the Credentials page. */
export function readTokens(): Record<string, string> {
  try {
    return JSON.parse(sessionStorage.getItem(TOKENS_STORAGE_KEY) ?? '') ?? {};
  } catch {
    return {};
  }
}
